<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_FEEDBACK',
        formComponent: {
          view: { type: 'component', componentName: 'Feedback-view', value: 'queryFeedbackDetailData', noRequest: true },
          list: { type: 'default', value: '/modules/feedback/feedbackList' },
          delete: { type: 'default', value: '/modules/feedback/feedbackDelete' }
        },
        formInputsData: [{ name: '反馈内容搜索', key: 'content', value: '', type: 'text' },
          { name: '搜索', key: 'userName', value: '', type: 'text' },
          { name: '创建时间', key: 'updateTimeRange', value: [], type: 'datetime' }],
        formButtonsData: [{ name: '删除', key: 'DELETE', action: 'DELETE_LIST', hidden: false, permission: 'DELETE' }],
        formTableData: [
          { name: '反馈内容', key: 'content', type: 'text', attr: { 'show-overflow-tooltip': true }},
          { name: '昵称', key: 'nickName', type: 'text' },
          { name: '手机号', key: 'phone', type: 'text' },
          { name: '创建时间', key: 'createTime', sortable: 'custom', type: 'text' }],
        formTableButtonsData: [{ name: '查看', key: 'VIEW', action: 'VIEW', hidden: false, className: 'primary', permission: 'VIEW' },
          { name: '删除', key: 'DELETE', action: 'DELETE', className: 'danger', hidden: false, permission: 'DELETE' }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: true, index: true }
      }
    }
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      console.log('data', data)
      if (data && data.item) {
        if (data.item.action === 'VIEW') {
          this.$store.dispatch('setFeedbackDetailData', JSON.parse(JSON.stringify(data.row)))
        }
      }
    }
  }
}
</script>
